const FAQs = () => {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <h1 className="legal-title">Frequently Asked Questions</h1>
          <p className="legal-effective">Everything you need to know about Elderra</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            <h2>1. How It Works</h2>
            
            <div className="faq-item-legal">
              <h3>Q1: What is Elderra and how does it work?</h3>
              <p>Elderra is a platform designed to help seniors (50+ age group) become confident in using digital tools and technology. We offer various services like personalized training, group classes, and on-demand support. Seniors can book a session with a DigiCoach, join a group class, or access our digital concierge for real-time help.</p>
            </div>

            <div className="faq-item-legal">
              <h3>Q2: What is a DigiCoach?</h3>
              <p>A DigiCoach is a trained professional who helps seniors learn digital skills, use apps, and navigate technology. They provide personalized guidance through online or in-person sessions, ensuring hands-on learning.</p>
            </div>

            <div className="faq-item-legal">
              <h3>Q3: How can I book a session?</h3>
              <p>You can book a session online through the "Book Online" section on our website or by contacting us directly. Once booked, a DigiCoach will assist you with your specific needs.</p>
            </div>

            <h2>2. Why This is Important</h2>
            
            <div className="faq-item-legal">
              <h3>Q4: Why should seniors learn digital skills?</h3>
              <p>The world is becoming increasingly digital, and learning these skills helps seniors:</p>
              <ul>
                <li>Stay independent in daily tasks like ordering food or booking cabs.</li>
                <li>Protect themselves from online scams and fraud.</li>
                <li>Use financial apps to manage money and achieve financial freedom.</li>
                <li>Stay connected with family and friends through social media and messaging apps.</li>
              </ul>
            </div>

            <div className="faq-item-legal">
              <h3>Q5: How is Elderra different from other elder care services?</h3>
              <p>Unlike traditional elder care, which focuses on physical and health needs, Elderra empowers seniors to embrace technology. Our focus is on education, independence, and bridging the digital divide.</p>
            </div>

            <h2>3. Services and Programs</h2>
            
            <div className="faq-item-legal">
              <h3>Q6: What kind of apps and tools do you teach?</h3>
              <p>We offer training across various categories:</p>
              <ul>
                <li><strong>Everyday Apps:</strong> Zomato, Uber, PayTM, and more.</li>
                <li><strong>Advanced Tools:</strong> Stock trading apps, financial management tools.</li>
                <li><strong>Creative and Professional:</strong> AI tools for writing, designing, and more.</li>
              </ul>
            </div>

            <div className="faq-item-legal">
              <h3>Q7: Do you offer in-person training?</h3>
              <p>Yes, we offer both individual in-home training and group sessions in major cities. Our DigiCoaches provide hands-on support tailored to the senior's needs.</p>
            </div>

            <div className="faq-item-legal">
              <h3>Q8: Are there any free resources available?</h3>
              <p>Yes, we provide free tools and basic resources to help seniors get started with technology. For more advanced needs, we offer premium services through memberships.</p>
            </div>

            <h2>4. Membership and Pricing</h2>
            
            <div className="faq-item-legal">
              <h3>Q9: How much does it cost?</h3>
              <p>We have two membership options:</p>
              <ul>
                <li><strong>Monthly Plan:</strong> ₹999 per month.</li>
                <li><strong>Annual Plan:</strong> ₹5,499 per year.</li>
              </ul>
              <p>Both plans provide access to DigiCoaches, group classes, and personalized support.</p>
            </div>

            <div className="faq-item-legal">
              <h3>Q10: Can I cancel my membership anytime?</h3>
              <p>Yes, you can cancel your membership at any time through your account or by contacting us directly.</p>
            </div>

            <h2>5. Security and Safety</h2>
            
            <div className="faq-item-legal">
              <h3>Q11: How do you ensure online safety for seniors?</h3>
              <p>We offer specialized modules on:</p>
              <ul>
                <li>Recognizing online scams and fraud.</li>
                <li>Using secure passwords and two-factor authentication.</li>
                <li>Identifying fake or phishing emails and messages.</li>
              </ul>
            </div>

            <div className="faq-item-legal">
              <h3>Q12: Is my personal information safe with Elderra?</h3>
              <p>Yes, we prioritize your privacy and security. All personal data is handled in compliance with strict privacy standards.</p>
            </div>

            <h2>6. Support and Contact</h2>
            
            <div className="faq-item-legal">
              <h3>Q13: What should I do if I face a technical issue?</h3>
              <p>You can contact our support team via the "Help" section on our website. For immediate assistance, our digital concierge or DigiCoaches will be available to guide you.</p>
            </div>

            <div className="faq-item-legal">
              <h3>Q14: How can I partner with Elderra?</h3>
              <p>If you're interested in collaborating with us, visit the "Partner with Us" section or email us directly at contact@elderra.io.</p>
            </div>

            <div className="faq-item-legal">
              <h3>Q15: How do I join the Elderra WhatsApp community?</h3>
              <p>Click on the "Join Now" button in the "Community" section to become part of our WhatsApp group, where you can connect with other seniors and share your experiences.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQs;